import React from 'react';
import { FieldProps } from 'react-final-form';
import TextArea from 'components/final-form/TextArea';

export interface TextAreaFieldProps {
  name: string,
  component: any,
  validate?: any,
  rows?: number
}

export const textAreaInput = (fields: FieldProps, rows?: number): TextAreaFieldProps => {
  return {
    name: fields.name,
    component: TextArea,
    validate: fields.validate,
    rows: rows
  }
};
